import { ModalDialog } from './ModalDialog.ts'
import { escape_html } from './html.ts'

export interface ConfirmActionOptions {
  title: string
  message: string
  confirm_label?: string
  cancel_label?: string
  danger?: boolean
}

export function confirm_action (options: ConfirmActionOptions): Promise<boolean> {
  return new Promise((resolve) => {
    let settled = false
    const finish = (value: boolean, dialog: ModalDialog): void => {
      settled = true
      dialog.remove()
      resolve(value)
    }
    const dialog = new ModalDialog(
      options.title,
      build_confirmation_html(options),
      {
        customClass: 'confirmation-dialog',
        onClose: () => {
          if (!settled) {
            settled = true
            resolve(false)
          }
        }
      }
    )
    dialog.show()
    const root = dialog.get_element()
    root?.querySelector<HTMLButtonElement>('[data-confirm-action="confirm"]')
      ?.addEventListener('click', () => finish(true, dialog))
    root?.querySelector<HTMLButtonElement>('[data-confirm-action="cancel"]')
      ?.addEventListener('click', () => finish(false, dialog))
  })
}

export function build_confirmation_html (options: ConfirmActionOptions): string {
  const confirm_label = options.confirm_label ?? 'Confirm'
  const cancel_label = options.cancel_label ?? 'Cancel'
  const confirm_class = options.danger === true ? 'danger-button' : ''
  return `
    <div class="confirmation-dialog-body">
      <p>${escape_html(options.message)}</p>
      <div class="confirmation-dialog-actions">
        <button type="button" class="secondary-button" data-confirm-action="cancel">${escape_html(cancel_label)}</button>
        <button type="button"${confirm_class === '' ? '' : ` class="${confirm_class}"`} data-confirm-action="confirm">${escape_html(confirm_label)}</button>
      </div>
    </div>
  `
}

